/* eslint-disable tailwindcss/no-custom-classname */
import { styles } from './voice_style'

interface Props {
  onClick: () => void
  text: string
}

export const BgmLabel: React.FC<Props> = ({ onClick, text }) => {
  return (
    <div className="select-none player-label-bgm" onClick={onClick}>
      <div className="player-select-bgm">{text}</div>
      <style jsx>{styles}</style>
    </div>
  )
}
